module.exports = __webpack_public_path__ + "img/pic-paging-faq-1.9bf3266c.jpg";